import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserFacade } from './modules/user/+state/user.facade';
import { userReducer } from './modules/user/+state/user.reducers';
import { UserEffects } from './modules/user/+state/user.effects';
import { UserService } from './modules/user/+state/user.service';
import { TokenInterceptor, UnauthorizedInterceptor } from './modules/shared/interceptors';
import { AuthGuardService } from './modules/shared/guards/auth.guard';
import { authReducer } from './modules/auth/+state/auth.reducers';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MainComponent } from './main/main.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { AdminEffects } from './modules/admin/+state/admin.effects';
import { adminReducer } from './modules/admin/+state/admin.reducers';
import { AdminFacade } from './modules/admin/+state/admin.facade';
import { AdminService } from './modules/admin/+state/admin.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CountdownModule } from 'ngx-countdown';

const combinedReducers = {
  users: userReducer,
  auth: authReducer,
  admins: adminReducer,
};

@NgModule({
  declarations: [AppComponent, MainComponent],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    EffectsModule.forRoot([UserEffects, AdminEffects]),
    StoreModule.forRoot(combinedReducers),
    StoreDevtoolsModule.instrument({ maxAge: 25 }),
    BrowserAnimationsModule,
    MatSidenavModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatMenuModule,
    MatSnackBarModule,
    CountdownModule
  ],
  providers: [
    AuthGuardService,
    AdminFacade,
    AdminService,
    UserFacade,
    UserService,
    [
      {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: UnauthorizedInterceptor,
        multi: true,
      },
    ],
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
